angular.module('bribac.services.newReportModal', [
    'ui.bootstrap',
    'bribac.components.reportModal'
  ])

    .factory('newReportModal', function(
      $uibModal
    ) {
      return function(data, apiMethod, extension, showIncludeOptionalSamples) {
        return $uibModal.open({
          component: 'reportModal',
          resolve: {
            data: data,
            apiMethod: {apiMethod: apiMethod},
            extension: {value: extension},
            showIncludeOptionalSamples: showIncludeOptionalSamples
          },
          backdrop: 'static'
        })
      }
    })